import React, {useEffect, useState} from "react";
import {useRouter} from 'next/router';
import {fetchUserById} from '../../util/users';
import {formatDate} from '../../util/format';
import {requireAuth} from '../../util/auth';
import {fetchMeta} from '../../util/pages';
import wrapper from '../../store/store';
import {withUserGetServerSideProps} from '../../util/util';
import {UserAvatar} from '../../components/UserAvatar';
import {Typography} from '../../components/ui/typography';
import {User} from '@/types/user';


function UserPage() {
    const [user, setUser] = useState<User | null>(null);
    const router = useRouter();
    const userId = Array.isArray(router.query.id) ? router.query.id[0] : router.query.id;

    useEffect(() => {
        if (userId) {
            fetchUserById(userId).then((response) => {
                setUser(response);
            });
        }
    }, [userId]);

    if (!user?.id) {
        return null;
    }

    const isPositionVisible = (user.position_visible === undefined || user.position_visible) && user.position;
    const isEmailVisible = (user.email_visible === undefined || user.email_visible) && user.email;
    const isPhoneVisible = (user.phone_visible === undefined || user.phone_visible) && user.phone;
    const isCompanyVisible = (user.company_visible === undefined || user.company_visible) && user.company && user.company.name;
    const isBioVisible = user.bio;
    const isFunFactVisible = user.funfact;

    return (
        <section>
            <div className="w-full lg:w-8/12 px-4 mx-auto">
                <div
                    className="relative flex flex-col min-w-0 break-words w-full mb-6 rounded-lg mt-16">
                    <div className="px-6">
                        <div className="flex flex-wrap justify-center">
                            <div className="w-full px-4 flex justify-center">
                                <UserAvatar userId={user.id} className="h-[150px] w-[150px]" />
                            </div>
                        </div>
                        <div className="grid gap-2 text-center mt-12">
                            <h3 className="text-xl font-semibold leading-normal">
                                {user.first_name} {user.last_name}
                            </h3>
                            <Typography variant="muted">
                                member since {' '} {formatDate({ts: user.created, tz: user.timezone, format: 'medium'})}
                            </Typography>
                            {isPositionVisible ? (
                                <p>
                                    {user.position}
                                </p>
                            ) : null}
                            {isCompanyVisible ? (
                                <p>
                                    {user.company.name}
                                </p>
                            ) : null}
                            {isEmailVisible ? (
                                <p className="font-semibold">
                                    {user.email}
                                </p>
                            ) : null}
                            {isPhoneVisible ? (
                                <p className="font-semibold">
                                    {user.phone}
                                </p>
                            ) : null}
                        </div>
                        {isBioVisible ? (
                            <div className="mt-10 py-10 border-t">
                                <div className="flex flex-wrap justify-center">
                                    <div className="w-full lg:w-9/12 px-4">
                                        <Typography variant="h3" className="mb-4">
                                            About me
                                        </Typography>
                                        <p className="mb-4 text-lg leading-relaxed">
                                            {user.bio}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {isFunFactVisible ? (
                            <div className="mt-10 py-10 border-t">
                                <div className="flex flex-wrap justify-center">
                                    <div className="w-full lg:w-9/12 px-4">
                                        <Typography variant="h3" className="mb-4">
                                            Fun fact
                                        </Typography>
                                        <p className="mb-4 text-lg leading-relaxed">
                                            {user.funfact}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
}

export const getServerSideProps = wrapper.getServerSideProps(withUserGetServerSideProps(async (ctx) => {
    const content = await fetchMeta();
    return { props: {content} }
}));

export default requireAuth(UserPage);
